import React from 'react'
import './Login.css'
import Button from '@material-ui/core/Button'
import {auth,provider} from '../Firebase'
import {useStateValue} from './StateProvider'
import { actionTypes } from './Reducer'

function Login() {
    const [state,dispatch]=useStateValue()
    const signIn = () => {
           auth.signInWithPopup(provider).then((result) =>{
              console.log(result);
              dispatch({
                  type : actionTypes.SET_USER,
                  user : result.user
              })
          }).catch((err) => alert(err.message))
    }
    return (
        <div className="login">
            <div className="login__container">
              <img src="https://cdn.brandfolder.io/5H442O3W/at/pl546j-7le8zk-afym5u/Slack_Mark_Web.png" alt=""/>
              <h1>Sign in to Amine ladraa slack clone </h1>
              <p>Amine.slack.com</p>
              <Button onClick={signIn}>Sign in with google</Button>
            </div>
        </div>
    )
}

export default Login
